import { queries, requests } from 'RestAPIs/rapini';
import showSnackbar, { showErrorSnackbar } from 'components/shared/Snackbar';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useMutation } from 'react-query';

export const useDeclarationTypes = () => {
  const { t } = useTranslation('common');

  const {
    data: declarationTypes,
    isLoading,
    isError,
    refetch
  } = queries.useGetDeclarationTypes();

  const { mutate: deleteDeclarationType } = useMutation({
    mutationFn: (id: string) => requests.deleteDeclarationType(id),
    onSuccess: () => {
      showSnackbar({
        message: t('deleteSuccessfully'),
        severity: 'success'
      });
      refetch();
    },
    onError: () => {
      showErrorSnackbar();
    }
  });

  const onDeleteClick = useCallback(
    (ids: string[] | string) => {
      const id = Array.isArray(ids) ? ids[0] : ids;
      if (id) {
        deleteDeclarationType(id);
      }
    },
    [deleteDeclarationType]
  );

  return {
    declarationTypes,
    isLoading,
    isError,
    refetch,
    onDeleteClick
  };
};
